var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18.1C0 27.05 6.5 34.492 15 36V23h-4.5v-5H15v-4c0-4.5 2.9-7 7-7 1.3 0 2.7.2 4 .4V12h-2.3c-2.2 0-2.7 1.1-2.7 2.5V18h4.8l-.8 5h-4v13c8.5-1.509 15-8.949 15-17.9C36 8.146 27.9 0 18 0S0 8.145 0 18.1z",
    fill: "#4267B2"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDM2IDM2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDE4LjEwMDVDMCAyNy4wNDk1IDYuNDk5NSAzNC40OTEgMTUgMzZWMjIuOTk5NUgxMC41VjE4SDE1VjEzLjk5OTVDMTUgOS40OTk1IDE3Ljg5OTUgNy4wMDA1IDIyLjAwMDUgNy4wMDA1QzIzLjI5OTUgNy4wMDA1IDI0LjcwMDUgNy4yIDI1Ljk5OTUgNy4zOTk1VjEySDIzLjdDMjEuNDk5NSAxMiAyMSAxMy4wOTk1IDIxIDE0LjUwMDVWMThIMjUuOEwyNS4wMDA1IDIyLjk5OTVIMjFWMzZDMjkuNTAwNSAzNC40OTEgMzYgMjcuMDUxIDM2IDE4LjEwMDVDMzYgOC4xNDUgMjcuOSAwIDE4IDBDOC4xIDAgMCA4LjE0NSAwIDE4LjEwMDVaIiBmaWxsPSIjNDI2N0IyIi8+Cjwvc3ZnPgo=";
export { SvgFacebook as ReactComponent };